var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TicketCardVariant2',{staticClass:"px-4",attrs:{"ticket":_vm.ticketSeatLocation}})}
var staticRenderFns = []

export { render, staticRenderFns }